// productAudioPlayer.mixin use for newer product-card components

import { mapGetters } from 'vuex';

export default {
  data() {
    return {
      waveformWidth: 0,
      progress: {
        timeElapsed: 0, // Math.round(sound.position),
        timeTotal: 0,
        timeEstimated: 0,
      },
      sound: null, // init by soundManager
      // waveformHeight: 3, // this value are defined in PreviewAudio.vue
    };
  },
  computed: {
    ...mapGetters({
      playStatus: 'audioPlayer/playStatus', // manage playStatus in store due we limit play 1 sound
      currentSound: 'audioPlayer/currentSound',
      currentSoundId: 'audioPlayer/currentSoundId',
      sounds: 'audioPlayer/sounds',
    }),
    elementId() {
      return this.element ? this.element.id : null;
    },
    audioUrl() {
      return _.get(this.element, 'previews.mp3.url', null);
    },
    isSearchRepo() {
      return process.env.VUE_APP_PROJECT_NAME && process.env.VUE_APP_PROJECT_NAME === 'frontend-search';
    },
    isSearchResultPage() {
      return this.$route.name.indexOf('view-search') > -1;
    },
    isLoop() {
      // HTML5 support note: Native HTML5 looping is infinite when enabled > 1
      // http://www.schillmania.com/projects/soundmanager2/demo/api/#looping
      // if search repo, open loop
      return this.isSearchRepo ? 2 : 1;
    },
    isCurrentElement() {
      return this.elementId === this.currentSoundId;
    },
    isPlaying() {
      if (this.isCurrentElement) {
        return this.playStatus === 'playing' ? true : false;
      }
      return false;
    },
    classPlayStatus() {
      let showPlay = true;
      let showPause = false;

      if (this.isCurrentElement && this.currentSoundId) {
        showPlay = (this.playStatus === '' || this.playStatus === 'paused') ? true : false;
        showPause = this.isPlaying;
      }

      const classObject = {
        'me-bmt icon-play sm-play-icon': showPlay,
        'me-bmt icon-pause sm-pause-icon': showPause,
      };

      return classObject;
    },
    durationToMinutes() {
      const duration = _.get(this, 'details.duration');
      return duration ? this.$tools.secondToMinutes(duration) : '';
    },
  },
  mounted() {
    this.detectSavedProgress();
  },
  methods: {
    saveLocalProgress(progress) {
      // console.log('saveLocalProgress: ', progress);
      this.progress.timeElapsed = progress.timeElapsed;
      this.progress.timeTotal = progress.timeTotal;
      this.progress.timeEstimated = progress.timeEstimated;
    },
    detectSavedProgress() {
      // no detect/recover savedProgress when no in search result
      if (!this.isSearchResultPage) {
        return;
      }
      const hasSavedProgress = this.sounds.filter(x => x.id === this.elementId);
      if (hasSavedProgress.length > 0) {
        const savedSound = hasSavedProgress[0];
        this.saveLocalProgress(savedSound);
        console.log('[productAudioPlayer.mixin] saved progress recovered, id: ', savedSound.id, savedSound.timeEstimated);
      } else {
        console.log('[productAudioPlayer.mixin] find no save in store');
      }
    },
    clickAudioPlayButton() {
      // console.log('[productAudioPlayer.mixin] clickAudioPlayButton ELEMENT', this.element);

      // TODO: is this need
      if (!_.get(this.options, 'enablePlayer', true)) {
        return;
      }

      if (this.isCurrentElement) {
        switch (this.playStatus) {
          case 'playing':
            this.doAudioPlayerPause();
            break;
          case 'paused':
            this.doAudioPlayerResume();
            break;
          default:
            this.doAudioPlayerSetup();
            break;
        }
      } else {
        this.doAudioPlayerSetup();
      }
    },
    doAudioPlayerSetup() {
      this.doAudioPlayerStopAll();
      // this.detectSavedProgress(); // detect saved progress before setup
      this.$store.dispatch('audioPlayer/setCurrentSound', this.element);

      console.log('[productAudioPlayer.mixin] doAudioPlayer SETUP: ', this.elementId, this.sound);

      const self = this; // use component function in soundManager scope
      if (this.sound === null) {
        this.sound = this.$audioPlayer.player.createSound({
          id: this.elementId,
          url: this.audioUrl,
          whileplaying: function () {
            // only save to component whilePlaying
            const progress = {
              id: this.elementId,
              timeElapsed: Math.round(this.position),
              timeTotal: this.duration,
              timeEstimated: this.durationEstimate,
            };
            self.saveLocalProgress(progress);
          },
          onplay: function () {
            // no position event when onplay
            console.log('[productAudioPlayer.mixin] soundManager onplay');
            self.$store.dispatch('audioPlayer/setPlayStatus', 'playing');
            // if has saved progress, setPosition when onplay
            if (self.progress.timeElapsed > 0) {
              this.setPosition(self.progress.timeElapsed);
            }
          },
          onpause: function () {
            console.log('[productAudioPlayer.mixin] soundManager onpause');
            self.saveProgress(this);
            self.$store.dispatch('audioPlayer/setPlayStatus', 'paused');
          },
          onresume: function () {
            console.log('[productAudioPlayer.mixin] soundManager onresume');
            self.saveProgress(this);
            self.$store.dispatch('audioPlayer/setPlayStatus', 'playing');
          },
          onstop: function () {
            // when click other sound, $audioPlayer.stopAll() will get stop event.
            console.log('[productAudioPlayer.mixin] soundManager onstop');
            self.doAudioPlayerReset(); // when other component call stopAll, reset this audio.
            self.$store.dispatch('audioPlayer/setPlayStatus', '');
          },
          onfinish: function () {
            console.log('[productAudioPlayer.mixin] soundManager onfinish');
            const progress = {
              id: self.elementId,
              timeElapsed: 0,
              timeTotal: 0,
              timeEstimated: 0,
            };
            self.saveProgress(progress);
            self.$store.dispatch('audioPlayer/setPlayStatus', '');
            self.$store.dispatch('audioPlayer/setCurrentSound', null);
          },
        });
      }

      this.sound.play({
        url: this.audioUrl,
        loops: this.isLoop,
      });
    },
    saveProgress(sound) {
      const progress = {
        id: this.elementId,
        timeElapsed: Math.round(sound.position),
        timeTotal: sound.duration,
        timeEstimated: sound.durationEstimate,
      };
      this.saveLocalProgress(progress);
      this.$store.dispatch('audioPlayer/setSoundProgress', progress);
    },
    doAudioPlayerSetPosition(event) {
      // console.log('[productAudioPlayer.mixin] doAudioPlayerSetPosition : play status - ', this.playStatus);
      // when click playing audio's waveform
      if (this.sound !== null && this.playStatus && this.isCurrentElement) {
        // console.log('[productAudioPlayer.mixin] doAudioPlayerSetPosition: isPlayStatus && isCurrentElement');
        this.doAudioPlayerPause();

        // get mouse event position
        const duration = this.progress.timeTotal || this.progress.timeEstimated;
        const clickPositionX = event.offsetX;
        const mousePosition = Math.round((clickPositionX * duration) / this.waveformWidth);
        // console.log('[productAudioPlayer.mixin] click position :', this.waveformWidth, duration, clickPositionX);
        this.sound.setPosition(mousePosition);
        this.sound.play({
          loops: this.isLoop,
        });
      } else {
        // console.log('[productAudioPlayer.mixin] doAudioPlayerSetPosition: ELSE');
        this.doAudioPlayerSetup();
      }
    },
    updateWaveformWidth(value) {
      // update waveform every time when hit
      this.waveformWidth = value;
    },
    doAudioPlayerStopAll() {
      console.log('[productAudioPlayer.mixin] doAudioPlayer STOP ALL');
      this.$audioPlayer.stopAll();
      this.$store.commit('audioPlayer2025/reset');
    },
    doAudioPlayerStop() {
      console.log('[productAudioPlayer.mixin] doAudioPlayer STOP');
      // this.$audioPlayer.stopAll();
      this.sound.stop();
      // this.$store.dispatch('audioPlayer/setPlayStatus', '');
    },
    doAudioPlayerPause() {
      console.log('[productAudioPlayer.mixin] doAudioPlayer PAUSE');
      this.sound.pause();
      // this.$store.dispatch('audioPlayer/setPlayStatus', 'paused');
    },
    doAudioPlayerResume() {
      console.log('[productAudioPlayer.mixin] doAudioPlayer RESUME');
      // this.$audioPlayer.resumeAll();
      this.sound.resume();
      // this.$store.dispatch('audioPlayer/setPlayStatus', 'playing');
    },
    doAudioPlayerReset() {
      // console.log('[productAudioPlayer.mixin] doAudioPlayer RESET: ');

      if (this.sound) {
        this.sound.destruct(); // soundManger API
        this.sound = null;
      }
      this.$store.dispatch('audioPlayer/reset');
    },
  },
  beforeDestroy() {
    if (this.sound) {
      console.log('[productAudioPlayer.mixin] beforeDestory: sound player unload: ', this.elementId);
      this.doAudioPlayerStop();
      this.doAudioPlayerReset();
    }
  },
};
